import React, { useMemo, useState } from 'react';
import { Field, useFormikContext } from 'formik';
import { FormErrorUI, FormLabelUI, InputUI } from '../Interface';
import { TemplateDocumentLevel, TemplateType } from '../../config/template';
import TextTemplateMenu from './TextTemplateMenu';

const DocumentDescription = ({ viewField, currentDocType }) => {
  const { values, errors, setFieldValue } = useFormikContext();
  const [contextMenu, setContextMenu] = useState(null);
  const templates = useMemo(
    () =>
      (currentDocType?.template ?? []).filter(
        (template) =>
          template?.templateType === TemplateType.TEXT && template?.documentLevel === TemplateDocumentLevel.HEADER
      ),
    [currentDocType]
  );

  const handleContextMenu = (event) => {
    if (viewField) return;
    event.preventDefault();
    setContextMenu({ mouseX: event.clientX + 2, mouseY: event.clientY - 6 });
  };
  return (
    <div>
      <div className="col-span-full relative">
        <div className="mt-2">
          <div className="col-span-4 md:col-span-1">
            <Field
              type="text"
              name="note"
              as={InputUI}
              className={`${viewField ? 'rounded-md' : ''} resize-none h-36, p-2`}
              fullWidth
              label={<FormLabelUI text="Megjegyzés" />}
              variant="standard"
              helperText={<FormErrorUI message={errors.note} />}
              disabled={viewField}
              InputLabelProps={{ shrink: Boolean(values.note) }}
              multiline
              rows={4}
              onContextMenu={handleContextMenu}
            />
          </div>
          <div className="col-span-4 md:col-span-1">
            <Field
              type="text"
              name="internalNote"
              as={InputUI}
              className={`${viewField ? 'rounded-md' : ''} resize-none h-36, p-2`}
              fullWidth
              label={<FormLabelUI text="Belső megjegyzés" />}
              variant="standard"
              helperText={<FormErrorUI message={errors.internalNote} />}
              disabled={viewField}
              InputLabelProps={{ shrink: Boolean(values.internalNote) }}
              multiline
              rows={4}
            />
          </div>
        </div>
      </div>
      <TextTemplateMenu
        contextMenu={contextMenu}
        templates={templates}
        onClose={() => setContextMenu(null)}
        onSelect={(template) => {
          setFieldValue('note', template.body ?? '');
          setContextMenu(null);
        }}
      />
    </div>
  );
};

export default DocumentDescription;
